import BaseModelFactory from './base.factory'
import UsersUniversitySessionService from './../services/UsersUniversitySession.service'
import UsersUniversitySession from './../models/users-university-session.model'

class UsersUniversitySessionFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search(
      { search, pagination, order_by, method },
      { Service: UsersUniversitySessionService, Model: UsersUniversitySession }
    )
  static findById = async id =>
    await this._findBy({ id }, { Service: UsersUniversitySessionService, Model: UsersUniversitySession })
  static create = payload =>
    this._create(payload, {
      Service: UsersUniversitySessionService,
      Model: UsersUniversitySession,
    })
}

export default UsersUniversitySessionFactory
